import config from '../../../config';

import { AcePortalClientTypes } from './constants';

export const isAceWeb = () => AcePortalClientTypes.includes(config.auth.clientId);
